angular.module('backOffice').constant('uiMessages', {
    FileWrongExtension: 'File type is not valid. Please select another document.',
    DocExceedsMaxSize: 'Document exceeds maximum allowed size.',
    CancelSendMessage: 'Are you sure you would like to leave without sending a message?',
    CancelAssignUser: 'Are you sure you would like to leave without assigning?',
    ConfirmLeavePageHeader: 'Unsaved Changes',
    ConfirmLeavePage: 'Are you sure you want to leave this page? Your changes will not be saved.',
});
